import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:w-[calc(100vw-2rem)] group-[.toaster]:max-w-sm group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-white group-[.toast]:border group-[.toast]:border-transparent",
          cancelButton:
            "group-[.toast]:bg-white group-[.toast]:text-slate-700 group-[.toast]:border group-[.toast]:border-slate-200",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
